module.exports = "/_next/static/images/BreakdownSilosBetweenTeams-b2b9cc2df8eb44d66292af355cbb3c6b.webp";